<template>
  <div id="Billing" class="q-pa-md">
    <div class="text-h6 q-mx-md q-my-sm">{{ name }}</div>
    <div class="row">
      <div class="col-2 q-ma-sm" v-if="billings">
        <q-list class="buttons-list">
          <q-item
            v-for="item in billings"
            :key="item"
            clickable
            v-ripple
            :active="billing === item"
            @click="changeBillingsComponentSelect(item)"
            active-class="itemSelect"
            class="item q-pa-md q-ma-sm shadow-1"
          >
            <q-item-section> {{ $gettext(item.name) }}</q-item-section>
          </q-item>
        </q-list>
      </div>
      <q-card class="col-9 q-ma-md no-padding">
        <span v-for="item in billings" :key="item">
          <q-card-section v-if="billing === item" class="padding-crud">
            <crud-layout-search
              :ref="'crudLayoutSearch-' + item.name"
              :name="$gettext(item.name)"
              :interface="item.interface"
              :id="id"
              :noneselect="true"
              clean-layout
            />
          </q-card-section>
        </span>
      </q-card>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import { JtCrud } from 'jtech-webcomps'
const { CrudLayoutSearch } = JtCrud

@Component({
  name: 'Billing',
  components: {
    CrudLayoutSearch
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class Billing extends Vue {
  billings = [];
  billing = '';

  beforeMount () {
    this.billings = [
      {
        name: 'BILLING_CONDITIONS',
        interface: 'paymentCondition.pesquisar'
      },
      {
        name: 'BILLING_INSTRUMENTS',
        interface: 'paymentInstrument.pesquisar'
      }
    ]
    this.billing = this.billings[0]
  }

  changeBillingsComponentSelect (item) {
    this.billing = item
  }
}
export default Billing
</script>
<style lang="stylus" scoped>
#Billing {
  @import '~quasar-variables';

  .dataTableCrud {
    height: calc(65vh - 25px);
    box-shadow: none !important;
    padding: 0px;
  }

   .buttons-top-crud{
    margin-top: 5px;
    margin-bottom: -3px;
  }
  ::v-deep {
    .jt-crud-container {
      padding: 0%;
    }
  }

  .padding-crud {
    padding: 0px 10px 10px;
    margin-top: -15px;
  }

  .itemSelect {
    color: white;
    background: $secondary !important;
    border-left: 5px solid $dark !important;
    padding-left: 5% !imporant;
  }

  .item {
    background: white;
    font-weight: 500;
    padding-left: 10%;
    font-size: 1rem;
  }
}
</style>
